module.exports = __webpack_public_path__ + "static/media/ui_no.b98b8d26.svg";